import React from 'react'
import { useEffect } from 'react'
import "./main.css"
import "./com.css"


function Communication() {
    useEffect(() => {
        window.scroll(0,0)
    }, [])
    return (
        <div className="contenu">
            <div className="sidePhoto communication"></div>
            <div id="textCom">
                <h2>Communication</h2>
                    <p>Nous sommes là pour vous guider et vous <strong>accompagner</strong> dans vos <strong>choix</strong> de <strong>communication interne</strong> et 
                    <strong> externe</strong>.</p>
                    <p>Toujours <strong>à votre écoute</strong> avec comme objectif, vous proposer des <strong>solutions sur mesure</strong> avec un <strong>plan
                        d’action</strong> adapté à vos besoins ainsi qu’à votre budget.</p>
                    <p>Dans le but <strong>d’entretenir votre image</strong>, <strong>promouvoir vos activités</strong> et tisser des <strong>liens de proximité </strong>
                        avec le <strong>grand public</strong>, les <strong>institutions</strong>, vos <strong>partenaires</strong> et la <strong>presse</strong>.</p>
                    <p>Notre mission, s’adapter et <strong>se réinventer</strong> au quotidien en choisissant les <strong>bons canaux</strong> et la
                    <strong> meilleure stratégie</strong> pour <strong>la réussite de votre communication</strong>.</p>
                    <h3>Site web</h3>
                    <p>Nous <strong>créons</strong> et <strong>gérons</strong> votre <strong>site web</strong> pour qu’il soit <strong>efficace</strong> et fidèle <strong>à vote image</strong>.</p>
                    <h3>Community management</h3>
                    <p>Nous <strong>développons votre image</strong> et <strong>communiquons votre message</strong> à travers tous les réseaux sociaux :
                        Facebook, Instagram, Twitter, Youtube…</p>


                    <h3>Créations graphiques</h3>
                    <p>Besoin d’un <strong>logo</strong>, d’un <strong>flyer</strong> ou d’un <strong>visuel</strong>, nous concevons vos supports de communication à votre
                        image.</p>
                    <h3>Reportages photos</h3>
                    <p>Nous réalisons la <strong>couverture photographique</strong> de vos <strong>événements</strong>.</p>
                <div className='rajout_vide'></div>


            </div>
            
        </div>
    )
}

export default Communication
